import { render, staticRenderFns } from "./newClass.vue?vue&type=template&id=06cd9e31&"
import script from "./newClass.vue?vue&type=script&lang=js&"
export * from "./newClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports